import { EvolysProvider, CommandPalette } from "@evolys/ui";
import { PortalAuthProvider } from "@evolys/auth";
import { Notifications } from "@mantine/notifications";
import { SpotlightActionData } from "@mantine/spotlight";
import { useLocation, useNavigate } from "react-router-dom";
import {
  IconDashboard,
  IconClipboardList,
  IconFileText,
} from "@tabler/icons-react";

const API_BASE_URL =
  import.meta.env.VITE_API_URL ?? "http://localhost:5002";

function usePortalSpotlightActions(): SpotlightActionData[] {
  const navigate = useNavigate();

  return [
    {
      id: "dashboard",
      label: "Dashboard",
      description: "Go to dashboard",
      leftSection: <IconDashboard size={20} stroke={1.5} />,
      onClick: () => navigate("/"),
    },
    {
      id: "orders",
      label: "My Orders",
      description: "View your orders",
      leftSection: <IconClipboardList size={20} stroke={1.5} />,
      onClick: () => navigate("/orders"),
    },
    {
      id: "new-order",
      label: "New Order",
      description: "Submit a new sample order",
      leftSection: <IconClipboardList size={20} stroke={1.5} />,
      onClick: () => navigate("/orders/new"),
    },
    {
      id: "results",
      label: "Results",
      description: "View test results",
      leftSection: <IconFileText size={20} stroke={1.5} />,
      onClick: () => navigate("/results"),
    },
  ];
}

export function Providers({ children }: { children: React.ReactNode }) {
  const actions = usePortalSpotlightActions();
  const location = useLocation();
  const isSecureResultLink =
    location.pathname.startsWith("/result-link/");

  return (
    <EvolysProvider>
      <Notifications position="top-right" />
      <CommandPalette actions={actions} />
      <PortalAuthProvider
        apiBaseUrl={API_BASE_URL}
        skipSessionCheck={isSecureResultLink}
      >
        {children}
      </PortalAuthProvider>
    </EvolysProvider>
  );
}
